import React, { useContext } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { Trans } from '@lingui/react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

interface Props {
  errorCode?: string | number;
  text?: string;
}

function ErrorLayout({ errorCode = '404', text = null }: Props) {
  const appCtx = useContext(AppContext);
  const router = useRouter();

  return (
    <ContentWrapper>
      <Wrapper>
        <TextWrapper>
          <Heading>BLIMEY!</Heading>
          <Description>{text || <Trans id="error_page.description" />}</Description>
          <GoHome>
            <Trans id="error_page.goHome" />
          </GoHome>
          <ErrorCode>
            {' '}
            <Trans id="error_page.errorCode" />: {errorCode}
          </ErrorCode>
        </TextWrapper>
        <ImageWrapper>
          <img
            src="//cdn-production.boatsetter.com/assets/v3/kraken-c256018044b12aa6fb2788e818984f0b.png"
            style={{ width: '100%', height: 'auto' }}
          />
        </ImageWrapper>
      </Wrapper>
    </ContentWrapper>
  );
}

export default ErrorLayout;

const ContentWrapper = styled.div`
  height: auto;
  background: #11354b;
`;

const Wrapper = styled.div`
  max-width: 1140px;
  padding: 8em 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media screen and (max-width: 700px) {
    flex-direction: column-reverse;
  }
`;

const Heading = styled.h1`
  font-style: normal;
  font-weight: 700;
  letter-spacing: -1px;
  color: white;
  font-size: 380%;
`;

const Description = styled.div`
  font-style: normal;
  font-weight: 600;
  color: white;
`;

const TextWrapper = styled.div`
  width: 50%;
  flex-basis: auto !important;
  text-align: left;

  @media screen and (max-width: 700px) {
    width: 100%;
    margin-top: 2em;
    text-align: center;
  }
`;

const ImageWrapper = styled.div`
  width: 50%;
  flex-basis: auto !important;

  @media screen and (max-width: 700px) {
    width: 100%;
    max-width: 300px;
  }
`;

const GoHome = styled.p`
  color: #8e9697;
`;

const ErrorCode = styled.p`
  color: #8e9697;
`;
